import { render } from "./forgetpsw.vue?vue&type=template&id=750c8c95&scoped=true"
import script from "./forgetpsw.vue?vue&type=script&lang=js"
export * from "./forgetpsw.vue?vue&type=script&lang=js"

import "./forgetpsw.vue?vue&type=style&index=0&id=750c8c95&lang=less&scoped=scoped"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750c8c95"]])

export default __exports__